import styled from 'styled-components';

interface ContainerProps {
  variant: string;
}

const getColorByVariant = (variant: string) => {
  if (variant.includes('A')) return '#28A745';
  if (variant.includes('B')) return '#22979A';
  if (variant.includes('C')) return '#960A0A';
  return '#520D0D';
};

export const ContainerButton = styled.div<ContainerProps>`
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;

  button {
    background: transparent;
    border: none;
    padding: 4px 8px;
    font-size: 10px;
    white-space: nowrap;
    cursor: pointer;
  }

  .capag-text {
    font-weight: 400;
    color: #6c757d;
  }

  .capag-value {
    color: ${({ variant }) => getColorByVariant(variant)};
    font-weight: 700;
  }
`;

export const Container = styled.div`
  @media only screen and (min-width: 768px) {
    position: relative;
  }
`;
